export default __webpack_public_path__ + "static/JosefinSans-Regular-a0311f7c50de08a1825bec62961bba9a.woff2";